import { Button } from '@lmc/ui-kit/src/general'
import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { ReactNode, useState } from 'react'
import { ButtonVariant } from '@lmc/ui-kit/src/general/Button/Button'
import { Tooltip } from 'antd'

type DrawerConfirmActionProps = {
  isLoading?: boolean
  onConfirm: () => void
  buttonProps: { variant?: string; title: string; icon?: ReactNode }
  actionProps: { title: string; content: string; confirmTitle: string }
  children?: ReactNode
  canNavigate?: boolean
  disabled?: boolean
  tooltip?: string
}
export const DrawerConfirmAction = ({
  isLoading,
  onConfirm,
  buttonProps,
  actionProps,
  children,
  canNavigate = true,
  disabled = false,
  tooltip,
}: DrawerConfirmActionProps) => {
  const { t } = useTranslation()

  const [showPrompt, setShowPrompt] = useState(false)

  const handleConfirmAction = () => setShowPrompt(true)

  const handleConfirmNavigation = () => {
    onConfirm()

    if (canNavigate) setShowPrompt(false)
  }

  return (
    <>
      {tooltip ? (
        <Tooltip
          title={<Text>{tooltip}</Text>}
          placement="bottom"
          overlayInnerStyle={{
            width: '400px',
            padding: '8px 16px',
          }}
        >
          <Button
            variant={buttonProps?.variant as ButtonVariant}
            onClick={handleConfirmAction}
            disabled={disabled}
          >
            {buttonProps?.icon}
            {buttonProps?.title}
          </Button>
        </Tooltip>
      ) : (
        <Button
          variant={buttonProps?.variant as ButtonVariant}
          onClick={handleConfirmAction}
          disabled={disabled}
        >
          {buttonProps?.icon}
          {buttonProps?.title}
        </Button>
      )}
      <NavigationModal
        modalTitle={actionProps.title}
        modalContentText={actionProps.content}
        modalConfirmText={actionProps.confirmTitle}
        modalCancelText={t('CANCEL')}
        showPrompt={showPrompt}
        confirmNavigation={handleConfirmNavigation}
        cancelNavigation={() => setShowPrompt(false)}
        confirmButtonProps={{
          variant: buttonProps?.variant === 'danger' ? 'danger' : 'primary',
          isLoading,
        }}
      >
        {children}
      </NavigationModal>
    </>
  )
}
